export default __webpack_public_path__ + "assets/fonts/DMSans-Italic-b9c9.ttf";